import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Personnel from './pages/Personnel';
import PersonnelDetail from './pages/PersonnelDetail';
import Roster from './pages/Roster';
import Bidding from './pages/Bidding';
import Qualifications from './pages/Qualifications';
import FRMS from './pages/FRMS';
import Audit from './pages/Audit';
import Settings from './pages/Settings';
import Schedules from './pages/Schedules';
import Assistant from './pages/Assistant';
import NetworkMap from './pages/NetworkMap';
import Optimizer from './pages/Optimizer';
import DisruptionDesk from './pages/DisruptionDesk';
import Login from './pages/Login';
import apiService from './services/api';

function RequireAuth({ children }: { children: JSX.Element }) {
  const location = useLocation();
  if (!apiService.isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/personnel" element={<Personnel />} />
                <Route path="/personnel/:id" element={<PersonnelDetail />} />
                <Route path="/roster" element={<Roster />} />
                <Route path="/optimizer" element={<Optimizer />} />
                <Route path="/irops" element={<DisruptionDesk />} />
                <Route path="/bidding" element={<Bidding />} />
                <Route path="/qualifications" element={<Qualifications />} />
                <Route path="/schedules" element={<Schedules />} />
                <Route path="/assistant" element={<Assistant />} />
                <Route path="/map" element={<NetworkMap />} />
                <Route path="/frms" element={<FRMS />} />
                <Route path="/audit" element={<Audit />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </RequireAuth>
        }
      />
    </Routes>
  );
}

export default App;
